import { render, staticRenderFns } from "./ListBadge.vue?vue&type=template&id=e07a8f10&scoped=true&"
import script from "./ListBadge.vue?vue&type=script&lang=js&"
export * from "./ListBadge.vue?vue&type=script&lang=js&"
import style0 from "./ListBadge.vue?vue&type=style&index=0&id=e07a8f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07a8f10",
  null
  
)

export default component.exports